const appLoaded = () => {
  setTimeout(() => {
    document.body.classList.add('app-loaded');
  }, 0);
};

export default appLoaded;
